import { Record } from 'immutable';

const TradeInRecord = new Record({
    id: null,
    status: 0,
    leadId: null,
    tradeInVehicle: {
        id: '',
        make: '',
        model: '',
        trim: '',
        style: '',
        year: '',
        exteriorColor: '',
        vin: '',
        odometer: '',
    },
    estimation: {
        amount: 0,
        high: 0,
        low: 0,
    },
    evaluationQuestion: {},
    profile: {
        firstname: '',
        lastname: '',
        homePhone: '',
        email: '',
    },
});

class TradeInModel extends TradeInRecord {}

export default TradeInModel;
